import jsonpath from 'jsonpath';
import moment from 'moment';
import { Action } from 'redux';

import {
  ResultActionConstants,
  ResultState,
  ResultAction,
  SetSearchFilterArgs,
  SetPaginationArgs,
  SearchFilter,
  SetRequestListArgs,
} from './types';

export const initialState: ResultState = {
  resultNetworkStates: {
    resultRequest: {
      isRequesting: false,
    },
  },
  isInitialized: false,
  currentFilter: {
    dateFilter: 'today',
    status: 'all',
    fromDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
    toDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
  },
  currentPagination: {
    fromIndex: 0,
    toIndex: 0,
    totalRecords: 0,
    currentPage: 0,
    totalPages: 0,
    pageSize: 100,
  },
};

export default function resultReducer(
  state = initialState,
  action: Action<ResultActionConstants>,
): ResultState {
  switch (action.type) {
    case ResultActionConstants.INITIALIZE: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case ResultActionConstants.SEARCH_FILTER_SET: {
      const act = action as ResultAction<SetSearchFilterArgs>;
      const searchFilter: SearchFilter = {
        ...state.currentFilter,
      };

      jsonpath.value(searchFilter, `$.${act.path}`, act.value);
      return {
        ...state,
        currentFilter: searchFilter,
      };
    }
    case ResultActionConstants.PAGINATION_SET: {
      const act = action as ResultAction<SetPaginationArgs>;
      return {
        ...state,
        currentPagination: act.pagination,
      };
    }
    case ResultActionConstants.REQUEST_LIST_REQUEST: {
      return {
        ...state,
        resultNetworkStates: {
          ...state.resultNetworkStates,
          resultRequest: {
            ...state.resultNetworkStates.resultRequest,
            isRequesting: true,
          },
        },
      };
    }
    case ResultActionConstants.REQUEST_LIST_SET: {
      const act = (action as ResultAction<SetRequestListArgs>);
      return {
        ...state,
        resultNetworkStates: {
          ...state.resultNetworkStates,
          resultRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        requestLists: act.requestListResult,
        // currentPagination: act.requestListResult?.pagination!,
      };
    }
    default:
      return state;
  }
}
